/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller("OAuthCallbackCtrl",['$scope', '$routeParams', 'DebugHelper', 'V3OAuthResource', '$window', function($scope, $routeParams, DebugHelper, V3OAuthResource, $window){
  DebugHelper.register("OAuthCallbackCtrl", $scope);

  _.assignIn($scope, {

    initialize() {
      const params = {
        provider: $routeParams.id
      };

      return V3OAuthResource.authenticate(params
      , success => $window.location.href = Packs.iKnowRoutes.v3_dashboard_path()
      , error => $window.location.href = Packs.iKnowRoutes.v3_signin_path({error: "OauthError"}));
    }
  }
  );

  if ($routeParams.error) {
    DebugHelper.logError($routeParams.error_reason, $routeParams.error_description);
    return $window.location.href = Packs.iKnowRoutes.v3_signin_path({error: "OauthError"});
  } else {
    return $scope.initialize();
  }
}
]);
